export enum RewardEventCode {
    TKR = 'TKR',
    CC1 = 'CC1',
    CG1 = 'CG1'
}
